import { GoogleGenAI } from "@google/genai";
import { SYSTEM_INSTRUCTION } from "./constants";

export class GeminiService {
  private apiKey: string;

  constructor() {
    this.apiKey = process.env.REACT_APP_GEMINI_API_KEY || '';
    console.log("API Key loaded:", this.apiKey ? "Yes (length: " + this.apiKey.length + ")" : "No");
  }

  async sendMessage(history: { role: 'user' | 'model'; parts: { text: string }[] }[]) {
    try {
      if (!this.apiKey) {
        throw new Error("Clé API Gemini non configurée");
      }

      console.log("Sending message to Gemini...");
      const ai = new GoogleGenAI({ apiKey: this.apiKey });
      
      const lastMessage = history[history.length - 1];
      const userText = lastMessage?.parts[0]?.text || "";
      
      const response = await ai.models.generateContent({
        model: 'gemini-2.0-flash-lite',
        contents: SYSTEM_INSTRUCTION + "\n\nUser: " + userText,
      });

      console.log("Response received:", response);
      const text = response.text || "Je suis désolé, je n'ai pas pu générer de réponse.";

      return { text, urls: [] };
    } catch (error: any) {
      console.error("Gemini API Error:", error);
      console.error("Error message:", error?.message);
      console.error("Error details:", JSON.stringify(error, null, 2));
      throw error;
    }
  }
}

export const geminiService = new GeminiService();
